import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationTextMessage } from '@app/core/Enum';
import { CommonService } from '@app/core/Services';
import { RichTextEditorComponent } from '@syncfusion/ej2-angular-richtexteditor';

@Component({
  selector: 'app-edit-audit-report-popup',
  templateUrl: './edit-audit-report-popup.component.html',
  styleUrls: ['./edit-audit-report-popup.component.scss']
})
export class EditAuditReportPopupComponent implements OnInit {
  @ViewChild(RichTextEditorComponent) notes: RichTextEditorComponent;
  @Input() title: string;
  @Input() type: string;
  @Input() content: any;

  constructor(public commonService: CommonService, public dialogRef: MatDialogRef<EditAuditReportPopupComponent>) { }

  ngOnInit(): void {
    //do nothing
  }

  onSave(): void{
    if (!this.content || !this.title) {
      this.commonService.onFailure(NotificationTextMessage.emptyBody);
    } else if(this.content){
     let obj={
      content:this.content,
      title:this.title
     }
      this.dialogRef.close(obj);
    }
  }

  onCancel(res: boolean): void {
    this.dialogRef.close(res);
  }

 

}
